import "ckeditor5/ckeditor5.css";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import { Form } from "antd";
import {
    Bold,
    ClassicEditor,
    Essentials,
    Italic,
    List,
    Paragraph,
    RemoveFormat,
    Underline,
    Undo,
} from "ckeditor5";
import { FC, useMemo } from "react";

import { StyledCKEditorWrapper } from "./styles";

interface RichTextEditorProps {
    value?: string;
    onChange?: (value: string) => void;
    placeholder?: string;
    minHeight?: number;
    disabled?: boolean;
    error?: string;
    name?: string;
}

export const RichTextEditor: FC<RichTextEditorProps> = ({
    value,
    onChange,
    placeholder,
    minHeight = 160,
    disabled = false,
    error: errorProp,
    name,
}) => {
    const formInstance = Form.useFormInstance();
    const formError =
        name && formInstance ? formInstance.getFieldError(name)[0] : undefined;
    const error = errorProp ?? formError;
    const config = useMemo(
        () => ({
            plugins: [
                Essentials,
                Paragraph,
                Bold,
                Italic,
                Underline,
                RemoveFormat,
                List,
                Undo,
            ],
            toolbar: {
                items: [
                    "undo",
                    "redo",
                    "|",
                    "bold",
                    "italic",
                    "underline",
                    "removeFormat",
                    "|",
                    "bulletedList",
                    "numberedList",
                ],
                shouldNotGroupWhenFull: true,
            },
            placeholder,
        }),
        [placeholder],
    );

    return (
        <div>
            <StyledCKEditorWrapper
                $error={Boolean(error)}
                $minHeight={minHeight}
            >
                <CKEditor
                    editor={ClassicEditor}
                    config={config}
                    data={value ?? ""}
                    disabled={disabled}
                    onChange={(_, editor) => {
                        onChange?.(editor.getData());
                    }}
                />
            </StyledCKEditorWrapper>
        </div>
    );
};
